import React from 'react';
import {localized} from '../../data/traits';
import {DIFFICULTIES, COMMON_POOLS, NPC_BENCHMARKS, RULE_REMINDERS} from '../../data/cheatsheet';
import {vtmT} from '../../i18n';
import {formatPool} from '../SheetParts';

/** Aide-mémoire du MJ : difficultés, réserves courantes, repères de PNJ, rappels de règles. Replié par défaut. */
const VtmDmCheatsheet = ({lng}) => (
  <details className="vtmCheatsheet">
    <summary className="vtmCheatsheetSummary">{vtmT('cheatsheet')}</summary>
    <div className="vtmCheatsheetGrid">
      <section className="vtmCheatsheetBlock">
        <h3 className="vtmCategoryTitle">{vtmT('difficulties')}</h3>
        <dl className="vtmCheatsheetList">
          {DIFFICULTIES.map(item => (
            <div key={item.value} className="vtmCheatsheetRow">
              <dt className="vtmCheatsheetValue">{item.value}</dt>
              <dd>
                <span className="vtmCheatsheetName">{localized(item.name, lng)}</span>
                <span className="vtmCheatsheetNote">{localized(item.example, lng)}</span>
              </dd>
            </div>
          ))}
        </dl>
      </section>

      <section className="vtmCheatsheetBlock">
        <h3 className="vtmCategoryTitle">{vtmT('commonPools')}</h3>
        <dl className="vtmCheatsheetList">
          {COMMON_POOLS.map(item => (
            <div key={item.action.fr} className="vtmCheatsheetRow pool">
              <dt className="vtmCheatsheetName">{localized(item.action, lng)}</dt>
              <dd className="vtmCheatsheetNote">{formatPool(item.pool, lng)}</dd>
            </div>
          ))}
        </dl>
      </section>

      <section className="vtmCheatsheetBlock">
        <h3 className="vtmCategoryTitle">{vtmT('npcBenchmarks')}</h3>
        <table className="vtmCheatsheetTable">
          <thead>
            <tr>
              <th scope="col">{vtmT('npcType')}</th>
              <th scope="col">{vtmT('npcBest')}</th>
              <th scope="col">{vtmT('npcUsual')}</th>
            </tr>
          </thead>
          <tbody>
            {NPC_BENCHMARKS.map(item => (
              <tr key={item.type.fr}>
                <th scope="row">
                  <span className="vtmCheatsheetName">{localized(item.type, lng)}</span>
                  <span className="vtmCheatsheetNote">{localized(item.note, lng)}</span>
                </th>
                <td>{item.best}</td>
                <td>{item.usual}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="vtmCheatsheetFootnote">{vtmT('npcBenchmarksNote')}</p>
      </section>

      <section className="vtmCheatsheetBlock">
        <h3 className="vtmCategoryTitle">{vtmT('ruleReminders')}</h3>
        <ul className="vtmCheatsheetReminders">
          {RULE_REMINDERS.map(item => <li key={item.fr}>{localized(item, lng)}</li>)}
        </ul>
      </section>
    </div>
  </details>
);

export default VtmDmCheatsheet;
